/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Cta_ImportInputs */

const en_ui_studio_cta_import = /** @type {(inputs: Ui_Studio_Cta_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import GPX route`)
};

const de_ui_studio_cta_import = /** @type {(inputs: Ui_Studio_Cta_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPX-Route importieren`)
};

/**
* | output |
* | --- |
* | "Import GPX route" |
*
* @param {Ui_Studio_Cta_ImportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_cta_import = /** @type {((inputs?: Ui_Studio_Cta_ImportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Cta_ImportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_cta_import(inputs)
	return de_ui_studio_cta_import(inputs)
});